"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const common_1 = require("./common");
const any_1 = require("./any");
function getDateSchemaModifierProviders(getJoi) {
    const result = Object.assign(Object.assign({}, any_1.getAnySchemaModifierProviders(getJoi)), { iso: () => ({ schema }) => schema.iso(), max: (limit) => ({ schema }) => schema.max(limit), min: (limit) => ({ schema }) => schema.min(limit), timestamp: (type) => ({ schema }) => schema.timestamp(type) });
    return result;
}
exports.getDateSchemaModifierProviders = getDateSchemaModifierProviders;
exports.createDatePropertyDecorator = (joifulOptions) => (common_1.createPropertyDecorator()(({ joi }) => joi.date(), getDateSchemaModifierProviders, joifulOptions));
//# sourceMappingURL=date.js.map